import { render, staticRenderFns } from "./NewSrc.vue?vue&type=template&id=282ccedb&"
import script from "./NewSrc.vue?vue&type=script&lang=js&"
export * from "./NewSrc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports